import React from "react";
import cn from "classnames";
import styles from "./SocialIcons.module.scss";
import socialIconsData from "../../../data/socialIconsData.json"

interface SocialIconsProps {
    className?: string,
}

const SocialIcons: React.FC<SocialIconsProps> = ({className = ""}) => {
    return (
        <div className={cn(styles.socialIconWrap, className)}>
            {socialIconsData.map(item =>
                <a key={item.id} className={styles.socialIcon} href={item.link} target="_blank">
                    <img loading="lazy" className={styles.socialIconImg} src={item.icon} alt=""/>
                </a>
            )}
        </div>
    )
}
export default SocialIcons;